import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import DisplayRichTextString from 'components/RichTextEditorField/components/DisplayRichTextString';

import './AgreeToTcModal.styles.scss';

type AgreeToTcModalProps = {
  className?: string;
  termsAndConditionsContent: string;
} & ModalProps;

const AgreeToTcModal: React.ForwardRefRenderFunction<
  ModalRef,
  AgreeToTcModalProps
> = (props, ref) => {
  const { className, termsAndConditionsContent, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('agree-to-tc-modal', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('terms&Conditions')}
      {...rest}
    >
      <DisplayRichTextString disableShowMore>
        {termsAndConditionsContent}
      </DisplayRichTextString>
    </Modal>
  );
};

export default forwardRef(AgreeToTcModal);
